import MutateSettings from "./MutateSettings";

export default MutateSettings